import {
  createCognitoAuthConfig,
  type SignInOptions,
} from '@consolidocs-ui/components';

export const cognitoAuthConfig = createCognitoAuthConfig({
  authority: import.meta.env.VITE_COGNITO_AUTH_AUTHORITY,
  clientId: import.meta.env.VITE_COGNITO_AUTH_CLIENT_ID,
  clientSecret: import.meta.env.VITE_COGNITO_AUTH_CLIENT_SECRET,
});

/**
 * The shared sign-in page with email and password only: super-admins sign in
 * with their Cognito account, not through Google or Microsoft, on Cognito's
 * default background like the admin pool's managed login page.
 */
export const signInOptions: SignInOptions = { backdrop: 'shapes' };
